export const classNames = (array) => array.filter(Boolean).join(" ").trim();
export default classNames;
